import "css/AdminPage.css"
import {Link, Outlet, Route, Routes} from "react-router-dom"
import {Layout, Menu} from "antd"
import {label} from "services/label.service"
import PatientOverview from "components/admin/PatientOverview"
import DoctorOverview from "components/admin/DoctorOverview"
import Label from "components/Label"
import {Role} from "util/role"
import Authorization from "components/routing/Authorization"
import AdminOverview from "components/admin/AdminOverview"
import GraphContainer from "components/graph/GraphContainer"
import DownloadData from "./DownloadData";

const {Sider, Content} = Layout

export default function AdminPage() {
	return (
		<Authorization roles={Role.Admin}>
			<Routes>
				<Route path="" element={<AdminContent/>}>
					<Route path="users/">
						<Route path="patients" element={<PatientOverview/>}/>
						<Route path="doctors" element={<DoctorOverview/>}/>
						<Route path="admins" element={<AdminOverview/>}/>
					</Route>
					<Route path="data/">
						<Route path="graphs" element={<GraphContainer/>}/>
						<Route path="download" element={<DownloadData/>}/>
					</Route>
				</Route>
			</Routes>
		</Authorization>
	)
}

function AdminContent() {
	return (
		<Layout className="content_container">
			<Sider className="sider">
				<Menu className="sider">
					<Menu.ItemGroup key="user" title={label.get("admin.sider.users")}>
						<Menu.Item key="patients">
							<Link to="users/patients">
								<Label id="admin.sider.users.patients"/>
							</Link>
						</Menu.Item>
						<Menu.Item key="doctors">
							<Link to="users/doctors">
								<Label id="admin.sider.users.doctors"/>
							</Link>
						</Menu.Item>
						<Menu.Item key="admins">
							<Link to="users/admins">
								<Label id="admin.sider.users.admins"/>
							</Link>
						</Menu.Item>
					</Menu.ItemGroup>
					<Menu.ItemGroup key="graph" title={label.get("admin.sider.data")}>
						<Menu.Item key="download">
							<Link to="data/download">
								<Label id="admin.sider.data.download"/>
							</Link>
						</Menu.Item>
						<Menu.Item key="graph">
							<Link to="data/graphs">
								<Label id="admin.sider.data.graphs"/>
							</Link>
						</Menu.Item>
						<Menu.Item key="graph-extern">
							<a href="/graph" target="_blank" rel="noopener noreferrer">
								<Label id="admin.sider.data.graphs.external"/>
							</a>
						</Menu.Item>
					</Menu.ItemGroup>
				</Menu>
			</Sider>
			<Content className="content_container">
				<Outlet/>
			</Content>
		</Layout>
	)
}

